//======================================================================
//
//        Copyright (C) 2019 www.trycheers.com
//        All rights reserved
//
//        description :
//        chuangqi FrontBasic Framework main Entrance;
//        version:1.0.0
//        created by tracy at  03/06/1019
//        http://www.trycheers.com
//        trycheersoa version 1.2
//        
//======================================================================


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routerhandler from './router'
import http from "./helper/http";
import tips from './helper/tips';
import store from './store';
import localStorage from './helper/localStorage';
import '../static/css/element-variables.scss'
import '../static/css/reset.css'
import '../static/css/public.css'
import ElementUI from 'element-ui';
import dateformat from "./helper/dateformat.js";
import formvalidate from "./helper/formvalidate.js";
import echarts from 'echarts'
import moment from "moment"

//ueditor
import '../lib/ueditor/ueditor.config.js'
import '../lib/ueditor/ueditor.all.min.js'
import '../lib/ueditor/lang/zh-cn/zh-cn.js'
import '../lib/ueditor/ueditor.parse.min.js'

let router = routerhandler.router;

//载入elementui
Vue.use(ElementUI);

/**
 * echarts
 */
Vue.prototype.echarts = echarts;

/**
 * 人事相关时间选择
 */
Vue.prototype.personPicOptions = {
  shortcuts: [{
    text: '今天上午',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date());
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', date.split(' ')[0] + ' 12:00:00']);
    }
  }, {
    text: '今天下午',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date());
      picker.$emit('pick', [date.split(' ')[0] + ' 13:30:00', date.split(' ')[0] + ' 18:00:00']);
    }
  }, {
    text: '今天全天',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date());
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', date.split(' ')[0] + ' 18:00:00']);
    }
  }, {
    text: '明天上午',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 1)));
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', date.split(' ')[0] + ' 12:00:00']);
    }
  }, {
    text: '明天下午',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 1)));
      picker.$emit('pick', [date.split(' ')[0] + ' 13:30:00', date.split(' ')[0] + ' 18:00:00']);
    }
  }, {
    text: '明天全天',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 1)));
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', date.split(' ')[0] + ' 18:00:00']);
    }
  }, {
    text: '后天',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 2)));
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', date.split(' ')[0] + ' 18:00:00']);
    }
  }, {
    text: '明天和后天',
    onClick(picker) {
      const date = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 1)));
      const enddate = dateformat.format('yyyy-mm-dd hh:mm:ss', new Date(new Date().setDate((new Date()).getDate() + 2)));
      picker.$emit('pick', [date.split(' ')[0] + ' 09:00:00', enddate.split(' ')[0] + ' 18:00:00']);
    }
  }]
}

/**
 * 企业微信扫码登录用户信息本地缓存标识
 */
Vue.prototype.qrloginKey = 'QYWXQRLOGINFLAG';

Vue.prototype.getParamsObjToString = function (obj) {
  let queryString = '';
  for (var key in obj) {
    queryString += `${key}=${obj[key]}&`;
  }
  return queryString.endsWith('&') == true ? queryString.substring(0, queryString.length - 1) : queryString;
}

Vue.prototype.runnerStatusList = [{
  id: -1,
  name: '全部'
}, {
  id: 0,
  name: '未开始'
}, {
  id: 1,
  name: '发布，等待接单'
}, {
  id: 2,
  name: '已接单'
}, {
  id: 3,
  name: '已送达'
}, {
  id: 4,
  name: '已完成'
}, {
  id: 5,
  name: '已退款-用户'
}, {
  id: 51,
  name: '已退款-跑男'
}, {
  id: 6,
  name: '申诉中'
}, {
  id: 7,
  name: '申诉差价支付中'
}, {
  id: 8,
  name: '申诉差价支付完成'
}];

/**
 * 提现申请状态
 */
Vue.prototype.cashApplyStatusList = [{
  id: -1,
  color: '#333333',
  name: '全部'
}, {
  id: 0,
  color: '#909399',
  name: '申请中'
}, {
  id: 1,
  color: '#409EFF',
  name: '申请通过，提现中'
}, {
  id: 2,
  color: '#F56C6C',
  name: '申请不通过'
}, {
  id: 3,
  color: '#67C23A',
  name: '已到账'
}];

Vue.prototype.countDisHours = function (beginDateTime, endDateTime) {
  var _totalHour = 0;
  //1、获取开始时间和结束时间之间的日
  var _beginDate = moment(beginDateTime);
  var _endDate = moment(endDateTime);

  //整理时间
  if (_beginDate.get("hour") < 9) {
    //开始时间小于9点，设置为9点
    _beginDate = _beginDate.hour(9);
  } else if (
    _beginDate.isBetween(
      moment(_beginDate).hour(12),
      moment(_beginDate).hour(13),
      "hour", {}
    )
  ) {
    //开始时间在12点-13点之间，设置为13点
    _beginDate.hour(13);
  } else if (_beginDate.get("hour") >= 18) {
    _beginDate.add(1, "d").hour(9);
  }
  if (_endDate.get("hour") > 18 || _endDate.get("hour") < 9) {
    //结束时间大于18点，设置为18点
    _endDate = _endDate.hour(18);
  } else if (
    _endDate.isBetween(
      moment(_endDate).hour(12),
      moment(_endDate).hour(13),
      "hour", {}
    )
  ) {
    //结束时间在12点-13点之间，设置为12点
    _endDate.hour(12);
  } else if (_endDate.get("hour") <= 9) {
    _beginDate.add(-1, "d").hour(18);
  }

  var _tempDateTime = _beginDate; //缓存一个日期，起始时开始时间
  while (moment(_tempDateTime).isSameOrBefore(_endDate, "day")) {
    //2.1、判断是否周日，周六
    var _week = moment(_tempDateTime).weekday();
    if (_week == 0 || _week == 6) {
      //是周末,不算入时间
      _tempDateTime.add(1, "d");
      continue;
    }

    if (moment(_tempDateTime).isSame(_beginDate, "day")) {
      if (moment(_tempDateTime).isSame(_endDate, "day")) {
        //开始时间和结束时间是同一天，结束时间-开始时间
        _totalHour += _endDate.diff(_beginDate, "hours", true);
        //如果跨越中午12点30分，减去一个小时
        if (
          moment(_tempDateTime)
            .hour(12)
            .minute(30)
            .isBetween(_beginDate, _endDate, "hour")
        ) {
          _totalHour -= 1;
        }
        _tempDateTime.add(1, "d");
        continue;
      } else {
        //开始时间和结束时间不是同一天，18点-开始时间
        _totalHour += moment(_beginDate)
          .hour(18)
          .diff(_beginDate, "hours", true);
        //如果跨越中午12点30分，减去一个小时
        if (
          moment(_tempDateTime)
            .hour(12)
            .minute(30)
            .isBetween(_beginDate, moment(_beginDate).hour(18), "hour")
        ) {
          _totalHour -= 1;
        }
        _tempDateTime.add(1, "d");
        continue;
      }
    } else if (moment(_tempDateTime).isSame(_endDate, "day")) {
      //是否和结束时间是同一天,结束时间-开始时间9点，
      _totalHour += _endDate.diff(moment(_endDate).hour(9), "hours", true);
      //如果跨越中午12点30分，减去一个小时
      if (
        moment(_tempDateTime)
          .hour(12)
          .minute(30)
          .isBetween(moment(_endDate).hour(9), _endDate, "hour")
      ) {
        _totalHour -= 1;
      }
      _tempDateTime.add(1, "d");
      continue;
    } else {
      _totalHour += 8;
      _tempDateTime.add(1, "d");
      continue;
    }
  }
  return _totalHour < 0 ? 0 : _totalHour;
}

Vue.prototype.statusList = [{
  id: 0,
  name: '禁用'
}, {
  id: 1,
  name: '启用'
}]

//加载全局css
//加载全局js

/**
 * 生产提示信息标志
 * False:不提示
 */
Vue.config.productionTip = false;

/**
 * 更新路由
 */
Vue.prototype.updateRouter = routerhandler.getRouters;

/**
 * 日期格式转换
 */
Vue.prototype.dateformat = dateformat;

/**
 * 表单验证规则
 */
Vue.prototype.formValidateInstance = new formvalidate();

/**
 * 将tips对象添加到Vue原型上
 * eg:
 * this.tips.show(msg,duration);
 */
Vue.prototype.tips = tips;

/**
 * 将localStorage添加到Vue原型上
 */
Vue.prototype.localStorage = localStorage;

/**
 * 将http访问接口挂载到Vue原型上，作为全局调用
 * in components eg:
 * this.http.get(url) return <Promise>;
 * this.http.post(url,paras) return <Promise>;
 * 返回Promise对象，也可以使用await关键词。
 */
Vue.prototype.http = http;

/**
 * elUItable属性全局配置
 */
Vue.prototype.elementTableConfig = {
  border: true,
  stripe: false,
  loadingText: '数据加载中',
  loadingSpinner: 'el-icon-loading',
  loadingBackground: 'rgba(0,0,0,0.8)',
  size: 'mini'
}

let loading;
Vue.prototype.elementLoding = function (text) {
  loading = this.$loading({
    lock: true,
    text: text,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}

Vue.prototype.elementLodingClose = function () {
  loading.close();
}


Vue.prototype.adminAccountCategoryList = [{
  id: 1,
  name: '管理员'
}, {
  id: 2,
  name: '用户'
}]

Vue.prototype.chiTypeList = [{
  id: 1,
  name: '文字'
}, {
  id: 2,
  name: '图片'
}, {
  id: 3,
  name: '富文本'
}
]

function replaceAll(input, a, b) {
  if (input.indexOf(a) >= 0)
    input = input.replace(a, b);
  else
    return input;
  return replaceAll(input);
}

Vue.prototype.replaceAll = function (input, a, b) {
  return replaceAll(input, a, b);
}

/**
 * 获取项目分配类型
 */
Vue.prototype.getDistributionCategoryName = function (id) {
  return Vue.prototype.distributionCategoryList.find(a => a.id == id) == null ? '未知' : Vue.prototype.distributionCategoryList.find(a => a.id == id).name;
}

/**
 * 项目分配类型
 */
Vue.prototype.distributionCategoryList = [{
  id: 1,
  name: '产品'
}, {
  id: 2,
  name: '设计'
}, {
  id: 3,
  name: 'Web前端'
}, {
  id: 4,
  name: 'IOS'
}, {
  id: 5,
  name: 'Android'
}, {
  id: 6,
  name: 'Php'
}, {
  id: 7,
  name: 'Java'
}, {
  id: 8,
  name: '.Net'
}, {
  id: 9,
  name: '测试'
}, {
  id: 10,
  name: '运维'
}]

Vue.prototype.$bus = new Vue();

Vue.prototype.FixedTo = function (number, count) {
  if (number != null && number != '')
    return parseFloat(number).toFixed(count);
  else
    return parseFloat('0').toFixed(count);
}

Vue.prototype.getStatusByDate = function (startdate, enddate) {
  if (new Date() < new Date(startdate))
    return { status: 0, name: '未开始' }
  else if (new Date() >= new Date(startdate) && new Date() <= new Date(enddate))
    return { status: 1, name: '进行中' }
  else
    return { status: 2, name: '已结束' }
}

/**
 * 项目bug相关参数配置
 */
Vue.prototype.projectBugParams = {
  levelArray: [{
    id: -1,
    name: '全部'
  }, {
    id: 0,
    name: '轻度'
  }, {
    id: 1,
    name: '一般'
  }, {
    id: 2,
    name: '严重'
  }, {
    id: 3,
    name: '非常严重（崩溃）'
  }],
  priorityArray: [{
    id: -1,
    name: '全部'
  },
  {
    id: 0,
    name: '正常处理'
  }, {
    id: 1,
    name: '加快处理'
  }, {
    id: 2,
    name: '紧急处理'
  }
  ]
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  console.log(to);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  /**
   * VueX Store 挂载
   */
  store: store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js